/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ProposalPreview from "../components/ProposalPreview";
import { getPublicProposal } from "../services/proposalApi";

/**
 * ProposalPublicPage — public, no-auth viewer for a proposal by token.
 * Mounted at `/p/:token`. Handles loading + expired + not-found states.
 */
export default function ProposalPublicPage() {
  const { token } = useParams();
  const [state, setState] = useState({ status: "loading", proposal: null });

  useEffect(() => {
    document.title = "Personal Proposal · MoveAbroadIQ";
    document.documentElement.style.scrollBehavior = "smooth";
    let cancelled = false;
    (async () => {
      try {
        const proposal = await getPublicProposal(token);
        if (!cancelled) setState({ status: "ready", proposal });
      } catch (err) {
        if (cancelled) return;
        setState({ status: err.code || "error", proposal: null });
      }
    })();
    return () => {
      cancelled = true;
      document.title = "MoveAbroadIQ";
    };
  }, [token]);

  if (state.status === "loading") {
    return (
      <div style={fallbackWrap}>
        <div style={fallbackInner}>
          <div style={{ opacity: 0.6, letterSpacing: "0.32em", fontSize: 11 }}>LOADING</div>
          <div style={{ marginTop: 14, fontFamily: "Cormorant Garamond, serif", fontSize: 26 }}>
            Preparing your proposal…
          </div>
        </div>
      </div>
    );
  }
  if (state.status === "not_found") {
    return <EmptyState title="Proposal not found" body="This link may be invalid or has been revoked." />;
  }
  if (state.status === "expired") {
    return <EmptyState title="Proposal no longer available" body="This proposal has expired or was archived. Please contact your advisor for a fresh copy." />;
  }
  if (state.status === "error") {
    return <EmptyState title="Something went wrong" body="Please try again in a moment." />;
  }
  return <ProposalPreview proposal={state.proposal} />;
}

const fallbackWrap = {
  minHeight: "100vh",
  background: "linear-gradient(180deg,#0A0F1C 0%,#0E1626 100%)",
  color: "#F7F5F2",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 24,
  fontFamily: "'Inter', system-ui, sans-serif",
};
const fallbackInner = { textAlign: "center", maxWidth: 520 };

function EmptyState({ title, body }) {
  return (
    <div style={fallbackWrap}>
      <div style={fallbackInner}>
        <div style={{ color: "#C68B98", letterSpacing: "0.32em", fontSize: 11, fontWeight: 600 }}>MOVEABROADIQ</div>
        <h1 style={{ fontFamily: "Cormorant Garamond, serif", fontSize: 44, marginTop: 16, lineHeight: 1.05 }}>{title}</h1>
        <p style={{ marginTop: 16, color: "rgba(232,234,240,0.75)", lineHeight: 1.7 }}>{body}</p>
      </div>
    </div>
  );
}
